const AUTH_PATHS = [
  "/login",
  "/register",
  "/signup",
  "/sign-in",
  "/sign-up",
  "/forgot",
  "/forgot-password",
  "/reset-password",
  "/verify-email",
  "/logout",
];

const INTERNAL_PATHS = ["/api", "/_next"];
const RETURN_URL_BASE = "https://return.invalid";
const ASCII_CONTROL = /[\u0000-\u001f\u007f]/;

function decodePath(rawPath: string): string | null {
  try {
    return decodeURIComponent(rawPath);
  } catch {
    return null;
  }
}

function matchesPath(pathname: string, blockedPath: string): boolean {
  return pathname === blockedPath || pathname.startsWith(`${blockedPath}/`);
}

function isAllowedPath(rawPath: string): boolean {
  const decodedPath = decodePath(rawPath);
  if (!decodedPath) return false;
  if (!decodedPath.startsWith("/") || decodedPath.startsWith("//"))
    return false;
  if (decodedPath.includes("\\") || ASCII_CONTROL.test(decodedPath))
    return false;
  if (
    decodedPath
      .split("/")
      .some((segment) => segment === "." || segment === "..")
  ) {
    return false;
  }

  const normalizedPath = decodedPath.toLowerCase();
  if (INTERNAL_PATHS.some((path) => matchesPath(normalizedPath, path))) {
    return false;
  }
  if (AUTH_PATHS.some((path) => matchesPath(normalizedPath, path))) {
    return false;
  }
  return true;
}

export function sanitizeNext(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (raw.length > 512) return null;
  if (!raw.startsWith("/")) return null;
  if (raw.startsWith("//")) return null;
  if (ASCII_CONTROL.test(raw)) return null;

  const rawPath = raw.split(/[?#]/, 1)[0];
  if (!isAllowedPath(rawPath)) return null;

  let canonical: URL;
  try {
    canonical = new URL(raw, RETURN_URL_BASE);
  } catch {
    return null;
  }
  if (canonical.origin !== RETURN_URL_BASE) return null;
  if (!isAllowedPath(canonical.pathname)) return null;

  return `${canonical.pathname}${canonical.search}${canonical.hash}`;
}
